module.exports = __webpack_public_path__ + "static/media/gigapet.b99b14da.png";